import { ActivityNotification } from './types';

const projectIdFor = (notification: ActivityNotification) =>
	Number(notification.actionPayload?.projectId || notification.projectId);

export const activityNotificationPath = (notification: ActivityNotification): string | null => {
	const projectId = projectIdFor(notification);
	if (!Number.isInteger(projectId) || projectId < 1) return null;
	const bidPackageId = Number(notification.actionPayload?.bidPackageId || 0);
	switch (notification.actionType) {
		case 'SCOPE_GAP_ANALYSIS':
			return `/project/${projectId}?tab=scope-gap-analysis`;
		case 'CHANGE_LOG':
			return `/project/${projectId}?tab=6`;
		case 'SCOPE_CHECKLIST':
			return `/project/${projectId}?tab=scope-checklists`;
		case 'BID_SUBMISSION':
			return bidPackageId > 0
				? `/project/${projectId}/bidPackageData/${bidPackageId}?tab=bidders`
				: `/project/${projectId}`;
		case 'CONTRACT_INCLUSION':
			return bidPackageId > 0
				? `/project/${projectId}/bidPackageData/${bidPackageId}?tab=contract-inclusions`
				: `/project/${projectId}?tab=3`;
		case 'AUTO_ANALYSIS_TRADE_SELECTION': {
			const runId = Number(notification.actionPayload?.tradeSelectionRunId || 0);
			return runId > 0
				? `/project/${projectId}?tradeSelectionRunId=${runId}`
				: `/project/${projectId}`;
		}
		case 'DRAWING_INGESTION':
			return `/project/${projectId}?openAutoAnalysis=1`;
		case 'BID_LIST_AUDIT_READY': {
			const runId = Number(notification.actionPayload?.bidListAuditRunId || 0);
			return runId > 0
				? `/project/${projectId}?tab=1&bidListAuditRunId=${runId}`
				: `/project/${projectId}?tab=1`;
		}
		case 'AUTO_ANALYSIS':
		case 'BID_INVITES':
		case 'PROJECT_MESSAGES':
			return `/project/${projectId}`;
		default:
			return `/project/${projectId}`;
	}
};

export const isActivityPopupSuppressedPath = (pathname: string) => {
	const normalized = String(pathname || '').replace(/\/$/, '');
	return (
		normalized === '/interactive-review' ||
		normalized === '/change-analysis-overlay' ||
		normalized === '/change-log-overlay' ||
		normalized === '/groupig-interactive-review' ||
		normalized.indexOf('/multi-package-interactive-review/') === 0 ||
		/^\/project\/[^/]+\/drawings\/[^/]+$/.test(normalized) ||
		normalized.indexOf('/exclusivity-review/') === 0
	);
};
